import styled from 'styled-components'
import Text from '../../text'

export const Radio = styled.div`
  width: 100%;
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
`
export const StyledText = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`
export const Inputs = styled(Text)`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5rem;
`

export const StyledInput = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  height: 40px;
  width: 40px;
  transition: all 0.15s ease-out 0s;
  background: ${(props) => props.theme.colors.grey};
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: inline-block;
  outline: none;
  position: relative;
  border-radius: 50%;
  &:hover {
    background: ${(props) => props.theme.colors.lightRed};
  }
  &:checked {
    background: ${(props) => props.theme.colors.red};
  }
  &:checked::before {
    width: 40px;
    height: 40px;
    display: flex;
    content: '✓';
    font-size: 1.5rem;
    font-weight: bold;
    align-items: center;
    justify-content: center;
  }
`
